import React, { PropsWithChildren } from "react";
import * as styles from "./CardTags.module.scss";
import clsx from "clsx";

type Props = {
  className?: string;
  position?: "absolute";
};

const CardTags: React.FC<PropsWithChildren<Props>> = ({
  children,
  className,
  position
}) => {
  return (
    <ul
      aria-label="Tags"
      className={clsx(
        styles.tags,
        { [styles.positionAbsolute]: position == "absolute" },
        className
      )}
    >
      {children}
    </ul>
  );
};

export default CardTags;
